import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#e51d2f99',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          paddingLeft: 24,
          paddingRight: 24,
          paddingTop: 8,
          paddingBottom: 8,
        },
        contained: {
          backgroundColor: '#e51d2f99',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#e51d2f99',
            boxShadow: 'none',
          },
        },
        outlined: {
          borderColor: '#e51d2f99',
          color: '#e51d2f99',
          '&:hover': {
            borderColor: '#e51d2f99',
            backgroundColor: 'rgba(229, 29, 47, 0.04)',
          },
        },
      },
    },
  },
});

export default theme;

